<div class="main-wrapper-section">
    <div class="common-header">
        <h3>Memberships</h3>
    </div>
    <div class="card-section">
        <div class="card-panel">
            <div class="field-form-panel">
                <div class="flex-form contracts-flex-form top-filter-panel">
                    <div class="form-group">
                        <label>Site</label>
                        <select [(ngModel)]="selectedCMSiteID" (change)="onChangeCMSite()" class="form-control" name="sites">
                            <option value="0">--ALL--</option>
                            <option *ngFor="let opt of cmSites" [value]="opt.siteID">
                                {{ opt.siteName }}
                            </option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label>Manager</label>
                        <select [(ngModel)]="selectedUserID" (change)="onChangeUserDD()" class="form-control" name="manager">
                            <option *ngFor="let opt of clpUsersDD" [value]="opt.value">
                                {{ opt.text }}
                            </option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label>Account Status</label>
                        <select [(ngModel)]="membershipAccountStatusID" (change)="onChangeStatus()" class="form-control" name="status">
                            <option value="0">--ALL--</option>
                            <option *ngFor="let opt of ref_MemAccountStatus_List" [value]="opt.statusID">
                                {{ opt.status }}
                            </option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label *ngIf="selectedCtDtFilter == 1 || selectedCtDtFilter == 2">Time Frame</label>
                        <div *ngIf="selectedCtDtFilter == 1 || selectedCtDtFilter == 2">
                            <select [(ngModel)]="selectedCtDtFilter" (change)="createDtFilterChange($event)" class="form-control" name="status">
                                <option *ngFor="let opt of createDateFilters" [value]="opt.value">
                                    {{ opt.name }}
                                </option>
                            </select>
                        </div>
                        <div class="custom-date" *ngIf="selectedCtDtFilter == 3 || selectedCtDtFilter == 4 || selectedCtDtFilter == 5 || selectedCtDtFilter == 6">
                            <label>Custom Range</label>
                            <div class="display-row">
                                <mat-form-field appearance="outline">
                                    <mat-date-range-input [rangePicker]="dateRangePicker" [formGroup]="currentRange"  [min]="minDate" [max]="maxDate" readonly>
                                        <input matStartDate placeholder="Start date" formControlName="start" #dateRangeStart readonly>
                                        <input matEndDate placeholder="End date" formControlName="end" #dateRangeEnd (dateChange)="dateRangeChange(dateRangeStart, dateRangeEnd)" readonly>
                                    </mat-date-range-input>
                                    <mat-datepicker-toggle class="custom-daterange-toggle" matPrefix [for]="dateRangePicker"></mat-datepicker-toggle>
                                    <mat-date-range-picker #dateRangePicker></mat-date-range-picker>
                                    <span *ngIf="currentRange.controls.start.hasError('matStartDateInvalid')"><mat-error>Invalid start date</mat-error></span>
                                    <span *ngIf="currentRange.controls.end.hasError('matEndDateInvalid')"><mat-error>Invalid end date</mat-error></span>
                                </mat-form-field>
                                <i class="fa fa-undo" (click)="revertCustomFinalizeddtFilter()" style="font-size:20px; margin-left:10px;"></i>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label>Search</label>
                        <div class="button-group">
                            <input matInput class="form-control" (keyup)="applyFilter($event.target.value)" placeholder="Search">
                        </div>
                    </div>
                </div>
            </div>
            <div class="table-panel">
                <div class="mb-3">
                    <div class="text-right">
                        <div class="button-group" style="border:none;">
                            <!--<button class="primary-btn" style="min-width:100px;" [routerLink]="['/mem-membership/0']">Add</button>-->
                        </div>
                    </div>
                </div>
                <div class="table-body">
                    <table mat-table [dataSource]="dataSource" class="contracts-table" matSort>
                        <ng-container matColumnDef="position">
                            <th mat-header-cell *matHeaderCellDef></th>
                            <td mat-cell *matCellDef="let row; let i = index"><div class="members-name">{{ i + 1 }}</div></td>
                        </ng-container>
                        <ng-container matColumnDef="membershipID">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
                            <td mat-cell *matCellDef="let element"> <div class="members-name">{{element.membershipID}}</div></td>
                        </ng-container>
                        <ng-container matColumnDef="membershipAccountName">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header="membershipAccountName">Primary Member</th>
                            <td mat-cell *matCellDef="let element"><a class="members-name" (click)="$event.stopPropagation(); navToMemContact(element?.contactID)">{{element.membershipAccountName}}</a></td>
                        </ng-container>
                        <!--<ng-container matColumnDef="primaryCaptainName">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header="primaryCaptainLastName">Name</th>
                            <td mat-cell *matCellDef="let element"><a href="javascript:void(0)" (click)="navToMemContact(element?.contactID)">{{element.primaryCaptainName}}</a></td>
                        </ng-container>-->
                        <ng-container matColumnDef="membershipCompany">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Company</th>
                            <td mat-cell *matCellDef="let element"><div class="members-status">{{element.membershipCompany}}</div></td>
                        </ng-container>
                        <ng-container matColumnDef="accountStatus">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
                            <td mat-cell *matCellDef="let element"><div class="members-status">{{element.accountStatus}}</div></td>
                        </ng-container>
                        <ng-container matColumnDef="subscriptionType">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Subscription</th>
                            <td mat-cell *matCellDef="let element"><div class="members-date">{{element.subscriptionType}}</div></td>
                        </ng-container>
                        <ng-container matColumnDef="membershipStartDate">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Started</th>
                            <td mat-cell *matCellDef="let element"><div class="members-date">{{formatDate(element.membershipStartDate)}}</div></td>
                        </ng-container>
                        <ng-container matColumnDef="salesClosedDate">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Closed</th>
                            <td mat-cell *matCellDef="let element"><div class="members-date">{{formatDate(element.salesClosedDate)}}</div></td>
                        </ng-container>
                        <ng-container matColumnDef="currentARDate">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Current A/R</th>
                            <td mat-cell *matCellDef="let element"><div class="members-date">{{formatDate(element.currentARDate)}}</div></td>
                        </ng-container>
                        <ng-container matColumnDef="dtOnboarded">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Onboarded</th>
                            <td mat-cell *matCellDef="let element"><div class="members-date">{{formatDate(element.dtOnboarded)}}</div></td>
                        </ng-container>
                        <ng-container matColumnDef="Last12MonthsReservations">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Reservations (last 12)</th>
                            <td mat-cell *matCellDef="let element"><div class="members-date">{{element.last12MonthsReservations}}</div></td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selectRow(row)">
                        </tr>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>

